<template>
    <div class="shadow" v-if="isShow" @click="isShow = false">
        <div class="minutes-detail" @click.stop>
            <div class="title">
                多退少補
                <span>完成刷卡時通知</span>
            </div>
            <div class="note">
                <div>您送出任務後，系統即預刷此筆任務費用，</div>
                <div>待任務結束後，<span class="red">將立即自動刷卡，進行多退少補。</span></div>
                <div>* 多退：將任務多餘款項退還給您，因銀行作業關係，約需28天後退還帳戶，若有款項疑慮請聯繫跑跑腿客服。</div>
                <div>* 少補：將任務不足款項補刷，刷完將另行通知。</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'PaymentDetail',
        data() {
            return {
                isShow: false,
            }
        },
        methods: {
            show() {
                this.isShow = true;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .shadow {
        z-index: 20;
        position: absolute !important;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.4);
        width: 100%;
        height: 100%;
    }

    .minutes-detail {
        border-radius: 6px;
        background-color: rgba(255,255,255,1);
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        padding: 15px;
        position: absolute;
        bottom: 65px;
        right: 15px;
        left: 15px;
        text-align: left;
        color: #4A4A4A;
        font-size: 12px;

        .title {
            font-size: 16px;
            font-weight: 500;
            line-height: 22px;

            span {
                font-size: 12px;
                color: #9B9B9B;
                margin-left: 10px;
            }
        }

        .note {
            margin-top: 20px;
            line-height: 20px;

            .red {
                color: #F44336;
            }
        }
    }
</style>
